
import { Component, OnInit, ViewChild, Directive  } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AccessApi, ApiError } from 'app/backend/api';
import { ErrorComponent } from 'app/shared/error/error.component';
import { SuccessComponent } from 'app/shared/success/success.component';
import { environment } from 'environment';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { take } from 'rxjs/operators';


@Component({
  selector: 'app-ntc-register',
  templateUrl: './ntc-register.component.html',
  styleUrls: ['./ntc-register.component.scss']
})
export class NTCRegisterComponent implements OnInit {

  @ViewChild('error')
  public errorComponent: ErrorComponent;
  @ViewChild('success')
  public successComponent: SuccessComponent;
  @ViewChild('spinner')
  public spinner: ModalDirective;

  public customerName: string;
  public inputForm: UntypedFormGroup;
  public isSubmitted = false;
  public url = environment.backendUrl + environment.loginPath;
  constructor(
    private activatedRoute: ActivatedRoute,
    private accessService: AccessApi,
    private fb: UntypedFormBuilder,
  ) { }

  ngOnInit() {
    this.inputForm = this.fb.group({
      customerId: ['', Validators.required],
      email: ['', Validators.email],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      displayName: ['', Validators.required],
      applicationId: ['', Validators.required],
      instanceId: ['', Validators.required],
      roleId: ['', Validators.required]
    });

    this.activatedRoute.params.pipe(take(1)).subscribe(params => {
      if (!params['id']) {
        window.location.href = this.url;
      } else {
        this.accessService.prepareSelfRegistration(params['id']).pipe(take(1)).subscribe(advice => {
          this.customerName = advice.customerName;
          this.inputForm.patchValue({
            customerId: advice.customerId,
            applicationId: advice.applicationId,
            instanceId: advice.instanceId,
            roleId: advice.roleId
          });
        }, (err: ApiError) => {
          this.errorComponent.show(err.message, err.code);
        });
      }
    });

    this.inputForm.get('firstName').valueChanges.subscribe(val => {
      this.setDisplayName();
    });

    this.inputForm.get('lastName').valueChanges.subscribe(val => {
      this.setDisplayName();
    });
  }

  setDisplayName() {
    this.inputForm.get('displayName').setValue(this.inputForm.get('firstName').value + ' ' + this.inputForm.get('lastName').value);
  }

  submitForm() {
    if (this.inputForm.valid) {
      this.spinner.show();
      this.accessService.selfRegistration(this.inputForm.value).subscribe(res => {
        this.spinner.hide();
        const message = res.email + ' is registered for Nederman Training Center';
        this.successComponent.show(message);
        this.inputForm.reset();
      }, (err: ApiError) => {
        this.spinner.hide();
        this.errorComponent.show(err.message, err.code);
      });
    } else {
      this.isSubmitted = true;
    }
  }

}
